// extracted by mini-css-extract-plugin
module.exports = {"character":"Character_character__1FKk5"};